/**
 * Vuex getters for the "analytics" module.
 *
 * Currently empty — the module has no state to expose (see store.js).
 */
export default {

}
